{
  "name": "tienda-buho",
  "version": "1.3.3",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "quierememucho": "ng serve --configuration=quieremeMucho",
    "abaco": "ng serve --configuration=abaco",
    "quimicaBrasil": "ng serve --configuration=quimicaBrasil",
    "multibags": "ng serve --configuration=multibags",
    "kioscoElMolino": "ng serve --configuration=kioscoElMolino",
    "sampler": "ng serve --configuration=sampler",
    "distridrinks": "ng serve --configuration=distridrinks",
    "starteens": "ng serve --configuration=starteens"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/material": "^18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-free": "^6.5.1",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-brands-svg-icons": "^6.4.2",
    "@fortawesome/free-regular-svg-icons": "^6.4.2",
    "@fortawesome/free-solid-svg-icons": "^6.4.2",
    "bootstrap": "^5.3.2",
    "rxjs": "~7.8.0",
    "tslib": "^2.6.2",
    "zone.js": "~0.14.10"
  },
  "overrides": {
    "esbuild": "^0.23.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.19",
    "@angular/cli": "^18.2.19",
    "@angular/compiler-cli": "^18.2.13",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.4"
  }
}
